import { Link, useColorMode } from "@chakra-ui/react";

export const ThemedLogo = (props) => {
  const { colorMode } = useColorMode();
  const linkColor = colorMode === "dark" ? "white.500" : "white.500";

  return <Link {...props} color={linkColor} _hover={{ textDecoration: "none", color: linkColor }} />;
};
